<template>
  <div class="layout layout--signup layout--padd">
    <Header header-text="The Product Focus Toolbox" />
    <HeaderBanner />
    <div class="u-width-wrapper">
      <div :class="['card', 'card--fullwidth']">
        <NuxtPage />
      </div>
    </div>
    <Footer />
  </div>
</template>

<style lang="scss">
  .layout--signup {
    .card {
      width: 100%;
      padding: 40px;
      display: flex;
      align-items: center;

      &:first-child {
        background-color: #f5f6f1;
      }
    }

    .u-width-wrapper {
      background: none;
      padding-top: 30px;
      padding-bottom: 30px;

      .card {
        flex-flow: column;
      }
    }

    .header {
      background: none;
      border: 0;
      position: relative;
      top: auto;
      left: auto;
      padding-bottom: 90px;

      .u-width-wrapper {
        background: none;
      }

      .logo {
        width: 150px;
        position: relative;
        left: auto;
      }
    }

    .header__background {
      top: 0;
    }

    .header__text {
      padding-top: 40px;
      margin-right: auto;
      margin-left: auto;
      place-self: flex-end flex-end;

      p {
        font-size: 2.5rem;
      }
    }
  }
</style>
